import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { formatDateOnly } from "../utils/dateTimeUtils";

export default function LiveDateTimeWidget({ align = "right" }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: align === "left" ? "flex-start" : "flex-end",
        minWidth: 170,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 700, color: "#183152", lineHeight: 1.2 }}>
        {now.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
          timeZone: "Asia/Manila",
        })}
      </Typography>
      <Typography variant="caption" sx={{ color: "text.secondary", lineHeight: 1.2 }}>
        {formatDateOnly(now)}
      </Typography>
    </Box>
  );
}
